module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-9.24134107.svg";